/* eslint-disable react/prop-types */
import * as React from 'react';
import { Button, Dialog, Grid, TextField, Select, MenuItem, InputLabel, FormControl, CircularProgress } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import ClearIcon from '@mui/icons-material/Clear';
import { useFormik } from 'formik';
import { getApi, postApi } from 'views/services/api';
import { toast } from 'react-toastify';
import Palette from '../../ui-component/ThemePalette';
import { laundarySchema } from 'schema';

const AddLaundary = (props) => {
  const { open, handleClose } = props;
  const [rooms, setRooms] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const initialValues = {
    name: '',
    quantity: '',
    amount: '',
    roomNumber: '' // New field for room number
  };

  React.useEffect(() => {
    const fetchRooms = async () => {
      setLoading(true);
      try {
        const hotelData = JSON.parse(localStorage.getItem('hotelData'));
        const response = await getApi(`api/room/viewallrooms/${hotelData?.hotelId}`);
        
        if (response.status === 200) {
          setRooms(response.data);
        } else {
          toast.error("Failed to fetch rooms");
        }
      } catch (error) {
        toast.error("Error fetching rooms");
      } finally {
        setLoading(false);
      }
    };

    fetchRooms();
  }, []);

  const AddData = async (values) => {
    try {
      console.log("values================>>>>",values)
      values.hotelId = JSON.parse(localStorage.getItem('hotelData')).hotelId;
      let response = await postApi('api/laundary/add', values);

      if (response.status === 200) {
        formik.resetForm();
        toast.success('Laundary added successfully');
      } else {
        toast.error(response.response.data.error);
      }
    } catch (e) {
      toast.error("Error adding laundry item");
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: laundarySchema,
    onSubmit: async (values) => {
      AddData(values);
      handleClose();
    }
  });

  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
        <DialogTitle
          id="scroll-dialog-title"
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Typography variant="h6">Add New Laundary Item</Typography>
          <Typography>
            <ClearIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <form>
            <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={12}>
                  <TextField
                    id="name"
                    name="name"
                    label="Item Name"
                    fullWidth
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                  <TextField
                    id="quantity"
                    name="quantity"
                    label="Quantity"
                    type="number"
                    fullWidth
                    value={formik.values.quantity}
                    onChange={formik.handleChange}
                    error={formik.touched.quantity && Boolean(formik.errors.quantity)}
                    helperText={formik.touched.quantity && formik.errors.quantity}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                  <TextField
                    id="amount"
                    name="amount"
                    label="Amount / Item"
                    type="number"
                    fullWidth
                    value={formik.values.amount}
                    onChange={formik.handleChange}
                    error={formik.touched.amount && Boolean(formik.errors.amount)}
                    helperText={formik.touched.amount && formik.errors.amount}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                  <TextField
                    id="totalAmount"
                    name="totalAmount"
                    label="Total Amount"
                    type="number"
                    fullWidth
                    disabled
                    value={formik.values.amount * formik.values.quantity}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                  <FormControl fullWidth>
                    <InputLabel id="roomNumber-label">Room Number</InputLabel>
                    <Select
                      labelId="roomNumber-label"
                      id="roomNumber"
                      name="roomNumber"
                      value={formik.values.roomNumber}
                      onChange={formik.handleChange}
                      error={formik.touched.roomNumber && Boolean(formik.errors.roomNumber)}
                    >
                      {loading ? (
                        <MenuItem disabled>
                          <CircularProgress size={24} />
                        </MenuItem>
                      ) : (
                        rooms.map((room) => (
                          <MenuItem key={room._id} value={room.roomNo}>
                            {room.roomNo}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContentText>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error">
            Cancel
          </Button>
          <Button
            onClick={formik.handleSubmit}
            variant="contained"
            sx={{
              backgroundColor: Palette.info,
              '&:hover': { backgroundColor: Palette.infoDark }
            }}
          >
            Add Item
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddLaundary;
